<!-- @format -->
<script lang="ts">
  import { onMount } from 'svelte';
  import { getStoresContext } from "~/stores";
  import type { StoresKey } from "~/stores";

  export let request_store_key: StoresKey;
  const { lang } = getStoresContext(request_store_key);

  let scriptLoaded = false;
  let storeId: string | null;
  let targetMap: HTMLDivElement;

  onMount(() => {
    const params = new URLSearchParams(window.location.search);
    storeId = params.get("store");

    if (!storeId) {
      storeId = "";
    }
    // Load the map script
    if (typeof window.$ !== "function" && typeof window.triplaKartta === "function") {
      scriptLoaded = true;
      initializeMap(storeId);
    } else {
      const script = document.createElement("script");
      script.src = "https://m.eldatouch.fi/triplakartta"
      script.onload = () => {
        scriptLoaded = true;
        initializeMap(storeId);
      }
      document.head.appendChild(script);
    }
    scrollToMap();
  })

  function initializeMap(id: string | null) {
    if (scriptLoaded && typeof window.triplaKartta === "function") {
      window.triplaKartta("mapcontainer", lang.get(), id);
    } else {
      console.error("Unable to load map script");
    }
  }
  // Target the map element and compensate the scroll
  function scrollToMap() {
    targetMap.scrollIntoView({ behavior: "instant", block: "start" });
    setTimeout(() => {
    let offset = -50;
    if (window.innerWidth <= 768) {
      offset = -550;
    } else if (window.innerWidth <= 991 && window.innerWidth > 475) {
      offset = -300;
    }
    window.scrollBy({ top: offset, behavior: "instant" });
  }, 200);
  }

</script>

<!-- Load jquery for the map -->
<svelte:head>
  <script src="https://code.jquery.com/jquery-3.6.0.min.js"></script>
</svelte:head>

  
<div
  class="map-wrapper"
  aria-hidden="true"
  bind:this={targetMap}
>
  <div id="mapcontainer"></div>
</div>

<style lang="scss">
  .map-wrapper {
    position: relative;
    width: 100%;
    left: 0;
    overflow: hidden;
    transition: all 0.5s;
    scroll-margin-top: 400px;
  }
</style>
